import styled from '@emotion/styled';
import { TextField } from '@mui/material';

import { customPalette } from '../../../../styles/theme';

export const FormGroup = styled.div`
  margin-bottom: 24px;
`;

export const Label = styled.div`
  color: #616e7c;
  font-size: 14px;
  margin-bottom: 8px;
`;

export const StyledTextField = styled(TextField)`
  .MuiInputBase-root {
    background-color: ${customPalette.accent.white};
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;

    fieldset {
      border-color: ${customPalette.grey[100]};
    }

    &.Mui-focused fieldset {
      border-color: ${customPalette.blue.main};
      border-width: 1px;
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${customPalette.grey[100]};
    }
  }

  .MuiOutlinedInput-root {
    height: 57px;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${customPalette.grey[100]};
  }

  .Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${customPalette.blue.main} !important;
    border-width: 1px;
  }

  input {
    padding: 12px 16px;

    &::placeholder {
      color: #757575;
      opacity: 1;
    }
  }
`;
